import { UserRoles } from '../../../types';
import { callExternalApi } from '../../callExternalApi';

export const fetchRoles = async () => {
  return await callExternalApi<UserRoles[]>({
    url: 'api/admin/roles',
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
